var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "en2JVFrROeQ1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5333 3000",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "d306c5d61aaf4262ba098e8ae8fb2132",
    "export-id": "6cf9099b4c714358afd98c8952158b27",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.111635 0 0 10.686171-993.499392-386.600681)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0-.1 0 371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1815,3210c-196-44-340-124-493-274-186-181-276-365-303-617-13-117-3-252,26-363c93-355,406-657,763-737c155-34,374-27,531,17c276,78,529,299,652,569c66,147,98,349,79,511-28,243-108,417-274,592-157,166-336,267-546,306-114,22-330,20-435-4Zm466-153c168-47,318-145,438-288c217-258,260-620,110-924-58-119-140-220-246-305-281-226-678-254-995-69-114,67-308,265-308,315c0,9,31,74,68,143c38,69,120,222,182,339c63,116,117,212,120,212c4,0,181-317,188-340c2-5-39-11-95-12l-98-3v-55-55l135-5l134-5l61-110l60-110l209-9c179-7,219-6,275,8c157,38,278,129,337,253c31,64,37,89,42,162c12,223-107,376-326,420-69,14-576,15-567,1c3-5,19-10,34-10c55,0,64-17,70-136l6-109l59-108c32-60,59-107,61-105c1,2,5,94,9,206c3,112,9,208,12,214c10,16,200,3,254-16c109-40,189-123,225-234c14-41,17-76,13-155-8-160-52-238-167-291-38-17-66-21-161-21-113,0-117,1-165,32-28,18-64,47-82,65-17,18-118,183-224,366l-192,333-96-3-95-3-185-322c-101-178-188-323-192-323-13,0-29,124-29,222c0,246,75,425,254,604c150,150,298,228,486,254c105,14,283,4,381-23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24678 0 0 1.30196-1142.21-547.148)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.948913 0 0 0.968669 207.103 59.7139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 78.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 39.3465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.5335 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5098,2096c-16-8-24-22-26-44-3-26,1-34,22-43c35-16,74-4,82,25c12,50-32,85-78,62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3450,2048c-11-27-90-313-90-328c0-5,24-10,54-10c51,0,53,1,62,33c9,30,13,32,54,32s45-2,54-32c9-32,10-33,67-33c42,0,57,3,54,13-2,6-22,77-45,157-58,206-47,190-130,190-64,0-71-2-80-22Zm98-126c16-80,16-82-18-82-18,0-30,5-30,13c0,28,23,127,29,127c4,0,12-26,19-58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4127,2063c-4-3-7-84-7-180v-173h103c87,0,110,3,147,23c61,31,83,65,88,137c10,137-71,200-257,200-37,0-71-3-74-7Zm206-114c24-29,22-90-4-123-16-20-29-26-60-26h-39v83c0,46,3,87,8,91c13,14,77-3,95-25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3763,2053c-23-4-23-7-23-139c0-177,13-204,95-204c53,0,65,9,65,46c0,29-3,34-24,34-33,0-38,20-36,138c3,139,4,132-27,131-16-1-38-4-50-6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4892,2049c-23-9-23-10-20-148c3-132,4-141,27-165c45-47,147-30,139,24-2,16-11,26-28,30-25,6-25,6-28,138l-3,132-32-1c-18,0-42-4-55-10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5282,2053c-23-5-23-5-20-148c3-136,4-145,27-169c45-47,147-30,139,24-2,16-11,26-28,30-25,6-25,6-28,138l-3,132-32-1c-18-1-42-4-55-6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4593,1963c-34-7-81-59-89-98-9-50,2-83,41-122c28-28,40-33,78-33c27,0,49,6,57,15c7,8,16,15,21,15s9-7,9-15c0-12,13-15,55-15h56l-3,128-3,127h-50c-45,0-50-2-53-23l-4-24-21,20c-24,23-60,32-94,25Zm95-89c41-29,23-84-28-84-32,0-50,17-50,46c0,20,32,54,50,54c3,0,16-7,28-16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5077,1964c-4-4-7-47-7-96c0-93,14-140,45-152c26-10,90-7,102,5c15,15,3,61-18,66-16,4-19,18-21,92l-3,86-45,3c-25,2-49,0-53-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3924,1855c-14-34,3-45,71-45h66l-3,28c-3,26-6,27-66,30-49,2-64,0-68-13Z",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M1611,922c-15-28-53-184-55-222-2-50,24-45,41,7c14,40,16,42,54,40c35-1,40-5,47-31c10-38,29-45,40-14c11,29-2,187-17,216s-95,32-110,4Zm60-89c13-36,5-53-27-53-20,0-25,4-20,16c3,9,9,27,12,40c8,32,22,30,35-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3454,905c-7-19-14-40-14-47s-11-48-24-90c-20-65-22-80-10-95c16-22,27-12,43,38c11,34,14,36,51,35s40-3,46-33c7-38,31-44,43-10c10,29-3,187-18,215-9,18-21,22-57,22-42,0-46-2-60-35Zm65-76c13-38,8-49-26-49-19,0-24,4-19,16c3,9,9,27,12,40c8,33,20,30,33-7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3735,930c-3-6-5-59-4-118s-2-114-5-123c-5-12,0-18,16-23c46-12,106-6,128,12c33,27,18,43-31,36l-40-7l7,101l7,100-31,16c-36,19-39,19-47,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4665,931c-10-17-58-206-59-235-2-47,22-43,44,8c20,43,22,45,58,42c32-3,38-8,42-32c6-36,35-44,43-12c8,33,1,148-13,197-11,41-11,41-60,41-27,0-51-4-55-9Zm63-126c-2-12-12-21-25-23-26-4-29,11-12,55c10,27,11,28,25,8c8-11,13-29,12-40Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4944,929c-4-7-6-59-6-117c1-65-3-110-10-119-18-22-1-28,73-28c51,0,72,4,79,15c16,25,5,35-35,35h-39l3,97l3,97-31,15c-21,12-32,13-37,5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5417,933c-4-3-7-56-7-118c0-72-4-115-12-123-17-17-6-23,60-29s102,7,102,37c0,18-5,19-41,14l-41-7l2,94c3,120,4,114-25,127-30,14-30,14-38,5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169,886c-12-26-25-48-29-51-5-3-19,14-32,37-19,36-28,43-53,43h-30l-8-109c-9-116-3-141,31-120c11,7,19,29,22,65c5,52,6,53,20,32c19-30,43-29,60,2c20,38,30,30,30-22c0-27,4-54,9-62c13-20,57-6,65,21c7,27-14,198-25,198-4,0-14,3-23,6-11,4-21-7-37-40Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996,914c-3-9-6-31-6-50c0-31-3-34-29-34s-30,4-36,40c-7,44-15,53-33,41-9-5-12-39-10-122l3-114h25c23,0,25,4,28,58c3,57,4,58,30,55c25-3,27-7,30-50c3-52,26-75,62-63c23,7,24,23,6,148-12,84-23,106-52,107-7,0-15-7-18-16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221,911c-5-9-11-62-15-119-5-87-4-103,9-108c28-11,45,16,45,70l1,51l18-22c18-22,51-31,51-15c0,4,7,16,16,27c13,17,16,18,24,5c5-8,10-36,10-62c0-44,2-48,25-48c36,0,48,31,39,103-4,34-8,74-9,90-2,31-3,32-32,41-19,6-25,0-42-39-24-54-38-54-66-3-22,41-60,56-74,29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2913,914c-33-14-41-28-23-39c6-3,10-40,10-81c0-59-3-74-15-74-28,0-15-31,20-46c54-22,113-18,156,12c45,31,54,65,34,132-16,52-44,85-88,101-36,14-54,13-94-5Zm90-42c23-25,31-101,15-132-8-14-23-26-34-28-19-3-22,4-28,59-10,101-8,119,12,119c11,0,26-8,35-18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4303,914c-33-14-41-28-23-39c6-3,10-40,10-81c0-59-3-74-15-74-28,0-15-31,20-46c54-22,113-18,156,12c47,32,56,67,34,133-17,53-45,84-88,100-36,14-54,13-94-5Zm90-42c23-25,31-101,15-132-8-14-23-26-34-28-19-3-22,4-27,65-10,104-9,113,11,113c11,0,26-8,35-18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2588,908c-14-11-14-24-6-88c6-55,6-81-3-97-17-31,2-50,56-59c72-10,147,29,132,70-4,9-22,11-61,8-51-4-56-3-56,16c0,15,7,22,28,24c42,5,35,32-10,36-30,3-38,7-38,23s7,19,54,19c72,0,95,23,43,45-44,18-117,20-139,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5213,902c-17-10-5-195,13-220c19-26,38-1,41,56c1,26,5,68,9,94c9,65-21,97-63,70Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3997,813c-4-3-7-17-7-30c0-26,13-28,108-17c40,5,52,11,52,24c0,10-7,21-16,24-21,8-129,8-137-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384,715c-9-23,3-45,25-45c25,0,34,14,26,40-7,23-43,27-51,5Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7aca50b65d7e7b06d0dae51574230d97.svg";
export { ForwardRef as ReactComponent };